<div
  class="readmore-selector-container d-flex flex-wrap justify-content-center align-items-center hide"
  #refEl
  #readMoreSelectorModal
  (click)="OnCheckOutsideClose()"
>
  <div class="selection-container p-4 position-absolute">
    <div class="header-container d-flex flex-wrap">
      <div class="w-100">
        <div
          class="text-center justify-content-center font-size-title font-weight-bold"
        >
          <span
            class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header">
            {{'public.global.close'
            | translate}}<i class="fas fa-times pl-2 theme-color-header"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="readmore-container container py-2">
      <iframe
        *ngIf="currentPopUpFrom === 'terms'"
        frameborder="0"
        width="100%"
        height="600"
        [src]="whitelabelService.getWhiteLabelTermsLink() | safe"
      ></iframe>
      <iframe
        *ngIf="currentPopUpFrom === 'policy'"
        frameborder="0"
        width="100%"
        height="600"
        [src]="whitelabelService.getWhiteLabelPrivacyLink() | safe"
      ></iframe>
    </div>
  </div>
</div>
